import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEye, FiEyeOff } = FiIcons;

export default function AuthInput({ label, type = 'text', value, onChange, placeholder, icon: Icon, error }) {
  const [show, setShow] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (show ? 'text' : 'password') : type;

  return (
    <div className="mb-4">
      {label && <label className="block font-sans text-xs font-semibold text-stone-500 uppercase tracking-widest mb-2">{label}</label>}
      <div className={`flex items-center bg-white/70 backdrop-blur-sm border rounded-2xl px-4 py-3.5 gap-3 transition-all ${error ? 'border-red-300' : 'border-white/80 focus-within:border-stone-300'}`}>
        {Icon && <SafeIcon icon={Icon} className="text-stone-300 text-lg flex-shrink-0" />}
        <input
          type={inputType}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 bg-transparent font-sans text-sm text-stone-800 placeholder:text-stone-300 focus:outline-none"
        />
        {isPassword && (
          <button type="button" onClick={() => setShow(s => !s)} className="text-stone-300 flex-shrink-0">
            <SafeIcon icon={show ? FiEyeOff : FiEye} className="text-lg" />
          </button>
        )}
      </div>
      {error && <p className="font-sans text-xs text-red-400 mt-1.5 ml-1">{error}</p>}
    </div>
  );
}